export const FILTERS_FIELDS_RELEASES = [
  'dateStartFrom',
  'dateStartTo',
  'module',
  'type',
  'description',
];
